import React, {useCallback} from 'react';
import b_ from 'b_';
import Select, {components} from 'react-select';
import I18N from 'assets/i18n/brandlift-project';

import {useCurrentOrg, useOrgsList, useChooseUserOrg} from 'client/common/hooks/orgs';

import './header2.css';

const i18nSelector = I18N.common.orgSelector;
const b = b_.with('header2');

const OWN_SURVEYS_ID = undefined;

const Input = (props: React.ComponentProps<typeof components.Input>) => {
    return <components.Input {...props} autoComplete={props.autoComplete} />;
};

export function OrgSelector() {
    const chooseUserOrg = useChooseUserOrg();

    const handleOrgChange = useCallback(
        async (orgId: number | undefined) => {
            await chooseUserOrg(orgId);
        },
        [chooseUserOrg]
    );

    const {isSuccess, data} = useOrgsList();

    const options: {
        value: number | undefined;
        label: string;
    }[] = (data?.orgs ?? []).map(org => ({value: org.id, label: org.name}));

    const orgOptions =
        options.concat({value: OWN_SURVEYS_ID, label: i18nSelector.ownSurveys}) ?? [];

    const orgId = useCurrentOrg();
    const currentOrgOption = orgOptions.find(option => option.value === (orgId ?? OWN_SURVEYS_ID));

    return isSuccess && orgOptions.length > 1 ? (
        <>
            <Select
                onChange={e => handleOrgChange(e!.value)}
                options={orgOptions}
                value={currentOrgOption}
                className={b('org-selector')}
                size='m'
                disabled={false}
                view='dl-clear'
                // отключаем автокомплит хрома/ябро
                components={{Input}}
                autoComplete='one-time-code'
            />
        </>
    ) : null;
}
